export default "__VITE_ASSET__DA_4v7aK__"